import { Directive, ElementRef, inject, input, OnInit } from '@angular/core';

@Directive({
  selector: 'td[coreTableCell]',
})
export class TableCellDirective implements OnInit {
  private el = inject(ElementRef);

  field = input<string>('', { alias: 'coreTableCell' });

  ngOnInit() {
    this.el.nativeElement.setAttribute('data-field', this.field());
  }
}
